module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [(_vm.loading === false) ? _c('div', {
    staticClass: "container slick-wrapper",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('img', {
      attrs: {
        "src": item.image.path
      }
    }) : _c('img', {
      attrs: {
        "src": item.image_mobile.path
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.loading === false) ? _c('div', {
    staticClass: "container about-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column content is-2",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.title)
    }
  }, [_vm._v("\n          " + _vm._s(_vm.paragraph.title) + "\n        ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "column content is-3",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('p', {
    staticClass: "key"
  }, [_vm._v("Chinese, Tibetan and Mongolian antiques, modern oriental reproduction furniture as well as lighting, carvings, figurines and accessories.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column content is-8",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d318f198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 749
// module chunks = 1